import { Skeleton } from "@shared-kernel/primary/shared/shadcn/ui/skeleton";
import { PageHeader } from "@shared-kernel/primary/shared/layout/shared-components/page-header";
import { PageWrapper } from "@shared-kernel/primary/shared/layout/shared-components/page-wrapper";

export const DocumentaryResourcesSkeleton = ({ title = "Ressources" }: { title?: string }) => (
  <PageWrapper>
    <PageHeader title={title} />
    <div className="space-y-8">
      {[0, 1].map(section => (
        <section key={section} className="space-y-3">
          <Skeleton className="h-4 w-40" />
          <div className="grid gap-3">
            {[0, 1, 2].map(card => (
              <Skeleton key={card} className="h-[86px] w-full rounded-lg" />
            ))}
          </div>
        </section>
      ))}
    </div>
  </PageWrapper>
);
